import { App, URLOpenListenerEvent } from "@capacitor/app";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const AppUrlListener: React.FC<any> = () => {
  let history = useHistory();

  useEffect(() => {
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      const slug = event.url.split("designbysweet.com/applinks").pop();
      if (slug) {
        history.push({ pathname: slug });
      }

      // If no match, do nothing - let regular routing logic take over
    });
    // eslint-disable-next-line
  }, []);

  return null;
};

export default AppUrlListener;
